import { createHoiPoiTheme } from '@Sage/hoi-poi-ui';
export let theme;
export const createTheme = function (overTheme) {
  if (overTheme === void 0) {
    overTheme = {};
  }
  theme = createHoiPoiTheme(overTheme);
  return theme;
};